import React, { useEffect, useRef } from "react";
import cornerstone from "cornerstone-core";
import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import dicomParser from "dicom-parser";

cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

interface ImageViewerProps {
  dicomUrl: string;
}

const DicomViewer: React.FC<ImageViewerProps> = ({ dicomUrl }) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = elementRef.current;

    if (!element || !dicomUrl) return;

    cornerstone.enable(element);

    // Το dicomUrl είναι πλέον blob URL
    const imageId = `wadouri:${dicomUrl}`;

    cornerstone
      .loadImage(imageId)
.then((image: any) => {
        cornerstone.displayImage(element, image);
      })
      .catch((err) => {
        console.error("Σφάλμα φόρτωσης DICOM:", err);
      });

    return () => {
      cornerstone.disable(element);
    };
  }, [dicomUrl]);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div
        ref={elementRef}
        className="w-[512px] h-[512px] bg-black rounded-lg shadow-lg"
      />
    </div>
  );
};

export default DicomViewer;
